import { StyledEngineProvider, ThemeProvider } from '@mui/material';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import Routes from 'routes';
import PrimaryTheme from 'styles/PrimaryTheme';
import './App.css';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { useEffect, useState } from 'react';
import { getToken, onMessageListener } from './firebaseInit';

function App() {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        cacheTime: 1000 * 60 * 7,
        enabled: false,
        staleTime: Infinity,
        retry: 1,
      },
    },
  });

  // Only wrap authenticated routes with GoogleOAuthProvider
  const AuthenticatedRoutes = ({ children }) => {
    if (!process.env.REACT_APP_GOOGLE_CLIENT_ID) {
      return children;
    }
    return (
      <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
        {children}
      </GoogleOAuthProvider>
    );
  };

  return (
    <div>
      <QueryClientProvider client={queryClient}>
        <StyledEngineProvider injectFirst>
          <ThemeProvider theme={PrimaryTheme}>
            <AuthenticatedRoutes>
              <Routes />
            </AuthenticatedRoutes>
            <ReactQueryDevtools />
          </ThemeProvider>
        </StyledEngineProvider>
      </QueryClientProvider>
    </div>
  );
}

export default App;
